<template>
  <WarningDialog
    v-if="dialogState.visible"
    :title="dialogState.title"
    :content="dialogState.content"
    :btnString="dialogState.confirmText"
    :cancelBtnString="dialogState.discardText"
    :confirmBtnLoading="dialogState.saving"
    topRightCloseEventName="dismiss"
    @confirm="onConfirm"
    @close="onDiscard"
    @dismiss="onDismiss"
  />
</template>

<script>
import { defineComponent } from 'vue'
import WarningDialog from '@/components/Dialog/WarningDialog.vue'
import { useUnsavedLeavePromptHost } from '@/use/useUnsavedLeavePrompt'

export default defineComponent({
  name: 'UnsavedLeaveDialog',
  components: {
    WarningDialog,
  },
  setup () {
    const { dialogState, onConfirm, onDiscard, onDismiss } = useUnsavedLeavePromptHost()

    return {
      dialogState,
      onConfirm,
      onDiscard,
      onDismiss,
    }
  },
})
</script>
